<app-expandable-card [title]="displayTitle()" [whiteBackground]="true">
  <div class="documents-table-wrapper fs-table">
    @if (isLoadingDocuments()) {
      <app-loading-section />
    } @else if (hasDocumentsError()) {
      <app-section-error (retry)="onRetryDocuments()" />
    } @else {
      <div class="table-container">
        <div class="table-actions">
          <div class="table-filters">
            <div class="filters-row">
              <mat-form-field class="search-field" appearance="outline">
                <mat-icon matPrefix class="material-icons-outlined">
                  search
                </mat-icon>
                <input
                  matInput
                  placeholder="Search documents"
                  [value]="documentsSearchInput()"
                  (input)="onDocumentsSearchChange($any($event.target).value)"
                />
              </mat-form-field>
              <button
                mat-stroked-button
                type="button"
                class="toggle-filters-button"
                (click)="toggleDocumentsFilters()"
                [class.active]="documentsFiltersOpen()"
                [attr.aria-pressed]="documentsFiltersOpen()"
                [attr.aria-expanded]="documentsFiltersOpen()"
                aria-controls="documents-filters-panel"
              >
                <mat-icon matPrefix class="filter-icon material-icons-outlined">
                  filter_alt
                </mat-icon>
                <span>Filter</span>
              </button>
            </div>
            @if (documentsFiltersOpen()) {
              <div class="filters-row" id="documents-filters-panel">
                @if (documentTypeOptions().length > 0) {
                  <mat-form-field
                    appearance="outline"
                    class="filter-select-field xlarge-filter-select-field"
                  >
                    <mat-icon matPrefix class="material-icons-outlined">
                      insert_drive_file
                    </mat-icon>
                    <mat-label>Document Type</mat-label>
                    <mat-select
                      multiple
                      [value]="selectedDocumentTypes()"
                      (selectionChange)="
                        onDocumentTypeFilterChange($event.value)
                      "
                    >
                      @for (type of documentTypeOptions(); track type) {
                        <mat-option [value]="type">{{ type }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (documentSourceOptions().length > 0) {
                  <mat-form-field
                    appearance="outline"
                    class="filter-select-field small-filter-select-field"
                  >
                    <mat-icon matPrefix class="material-icons-outlined">
                      topic
                    </mat-icon>
                    <mat-label>Source</mat-label>
                    <mat-select
                      multiple
                      [value]="selectedDocumentSources()"
                      (selectionChange)="
                        onDocumentSourceFilterChange($event.value)
                      "
                    >
                      @for (source of documentSourceOptions(); track source) {
                        <mat-option [value]="source">{{ source }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (documentUploadedByOptions().length > 0) {
                  <mat-form-field
                    appearance="outline"
                    class="filter-select-field large-filter-select-field"
                  >
                    <mat-icon matPrefix class="material-icons-outlined">
                      person
                    </mat-icon>
                    <mat-label>Uploaded By</mat-label>
                    <mat-select
                      multiple
                      [value]="selectedDocumentUploadedBy()"
                      (selectionChange)="
                        onDocumentUploadedByFilterChange($event.value)
                      "
                    >
                      @for (
                        uploadedBy of documentUploadedByOptions();
                        track uploadedBy
                      ) {
                        <mat-option [value]="uploadedBy">{{
                          uploadedBy
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }

                <button
                  mat-button
                  type="button"
                  class="clear-filters-button"
                  (click)="handleClearDocumentsFilters()"
                >
                  <mat-icon
                    matButtonIcon
                    class="clear-filters-icon material-icons-outlined"
                  >
                    close
                  </mat-icon>
                  <span>Clear Filters</span>
                </button>
              </div>
            }
          </div>
          @if (showUploadButton()) {
            <button
              mat-button
              class="upload-document-button"
              (click)="handleUploadDocument()"
            >
              <mat-icon class="upload-icon material-icons-outlined">
                file_upload
              </mat-icon>
              Upload Document
            </button>
          }
        </div>
        @if (documents().length === 0) {
          <app-table-empty-state
            title="No Documents Found"
            [message]="emptyMessage()"
          />
        } @else {
          <div class="table-scroll-wrapper">
            <table mat-table [dataSource]="documents()" class="documents-table">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                  <button
                    type="button"
                    class="header-cell sortable"
                    (click)="onDocumentsSortChange('name')"
                  >
                    <mat-icon class="material-icons-outlined name-column-icon">
                      insert_drive_file
                    </mat-icon>
                    <span>File Name</span>
                    <mat-icon class="material-icons-outlined">
                      {{ getSortIcon("name") }}
                    </mat-icon>
                  </button>
                </th>
                <td mat-cell *matCellDef="let doc" class="document-name">
                  <a
                    class="column-content-wrapper"
                    href="{{ doc.url }}"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <mat-icon class="material-icons-outlined"
                      >insert_drive_file</mat-icon
                    >
                    <span>{{ doc.name }}</span>
                  </a>
                </td>
              </ng-container>

              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>
                  <button
                    type="button"
                    class="header-cell sortable"
                    (click)="onDocumentsSortChange('id')"
                  >
                    <span>Document #</span>
                    <mat-icon class="material-icons-outlined">
                      {{ getSortIcon("id") }}
                    </mat-icon>
                  </button>
                </th>
                <td mat-cell *matCellDef="let doc">{{ doc.id }}</td>
              </ng-container>

              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>
                  <button
                    type="button"
                    class="header-cell sortable"
                    (click)="onDocumentsSortChange('type')"
                  >
                    <span>Type</span>
                    <mat-icon class="material-icons-outlined">
                      {{ getSortIcon("type") }}
                    </mat-icon>
                  </button>
                </th>
                <td mat-cell *matCellDef="let doc">{{ doc.type || "-" }}</td>
              </ng-container>

              <ng-container matColumnDef="source">
                <th mat-header-cell *matHeaderCellDef>
                  <button
                    type="button"
                    class="header-cell sortable"
                    (click)="onDocumentsSortChange('source')"
                  >
                    <span>Source</span>
                    <mat-icon class="material-icons-outlined">
                      {{ getSortIcon("source") }}
                    </mat-icon>
                  </button>
                </th>
                <td mat-cell *matCellDef="let doc">{{ doc.source || "-" }}</td>
              </ng-container>

              <ng-container matColumnDef="uploadedBy">
                <th mat-header-cell *matHeaderCellDef>
                  <button
                    type="button"
                    class="header-cell sortable"
                    (click)="onDocumentsSortChange('uploadedBy')"
                  >
                    <span>Uploaded By</span>
                    <mat-icon class="material-icons-outlined">
                      {{ getSortIcon("uploadedBy") }}
                    </mat-icon>
                  </button>
                </th>
                <td mat-cell *matCellDef="let doc">
                  {{ doc.uploadedBy || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="uploadedAt">
                <th mat-header-cell *matHeaderCellDef>
                  <button
                    type="button"
                    class="header-cell sortable"
                    (click)="onDocumentsSortChange('uploadedAt')"
                  >
                    <span>Uploaded At</span>
                    <mat-icon class="material-icons-outlined">
                      {{ getSortIcon("uploadedAt") }}
                    </mat-icon>
                  </button>
                </th>
                <td mat-cell *matCellDef="let doc">
                  {{ doc.uploadedAt || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="lastModified">
                <th mat-header-cell *matHeaderCellDef>
                  <button
                    type="button"
                    class="header-cell sortable"
                    (click)="onDocumentsSortChange('lastModified')"
                  >
                    <span>Last Modified</span>
                    <mat-icon class="material-icons-outlined">
                      {{ getSortIcon("lastModified") }}
                    </mat-icon>
                  </button>
                </th>
                <td mat-cell *matCellDef="let doc">
                  {{ doc.lastModified || "-" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="header-cell">
                    <span>Actions</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let doc" class="actions-cell">
                  <div class="actions-wrapper">
                    <a
                      mat-icon-button
                      class="action-button color-ginnie"
                      matTooltip="Open Document"
                      matTooltipPosition="above"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="{{ doc.url }}"
                    >
                      <mat-icon class="material-icons-outlined">
                        open_in_new
                      </mat-icon>
                    </a>
                    <button
                      mat-icon-button
                      class="action-button color-ginnie"
                      (click)="onDownloadDocument(doc)"
                      matTooltip="Download Document"
                      matTooltipPosition="above"
                    >
                      <mat-icon class="material-icons-outlined">
                        file_download
                      </mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      class="action-button color-error"
                      (click)="onDeleteDocument(doc)"
                      matTooltip="Delete Document"
                      matTooltipPosition="above"
                    >
                      <mat-icon class="material-icons-outlined"
                        >delete</mat-icon
                      >
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="documentsDisplayedColumns"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: documentsDisplayedColumns"
                class="table-row"
              ></tr>
            </table>
          </div>
          <div class="paginator-container">
            <mat-paginator
              [length]="totalDocumentsCount()"
              [pageSize]="documentsPageSize()"
              [pageIndex]="currentDocumentsPage()"
              [pageSizeOptions]="pageSizeOptions"
              (page)="handleDocumentsPageEvent($event)"
            />
          </div>
        }
      </div>
    }
  </div>
</app-expandable-card>
